let context = {
  config: {},
  environment: null,
  reducers: {},
  reducerPaths: null,
  routes: null,
  api: {},
  defaultLayout: null,
  isInternalApp: isInternalApp,
  isReportApp: isReportApp
}

function isInternalApp () {
  return context.config.name === 'internal-app'
}
function isReportApp () {
  return context.config.name === 'report-app'
}

export default context



// WEBPACK FOOTER //
// ./src/context.js